import React from 'react';
import { Link } from 'react-router-dom';

/**
 * CTA réutilisable vers le formulaire prospects /restez-informe
 *
 * Variantes :
 *   - "banner"  : large bandeau coloré (page d'accueil, page voyages)
 *   - "compact" : encart plus petit (à insérer dans une grille)
 *   - "inline"  : ligne d'appel à l'action discrète (en bas de page)
 */
const RestezInformeCTA = ({ variant = 'banner', context = 'home' }) => {
  if (variant === 'compact') {
    return (
      <div
        className="bg-gradient-to-br from-[#FFC400] via-[#FFD640] to-[#FFC400] rounded-2xl p-6 shadow-lg border-2 border-[#FFC400]/30"
        data-testid={`restez-informe-cta-compact-${context}`}
      >
        <div className="flex items-start gap-4">
          <div className="text-4xl flex-shrink-0" aria-hidden>📬</div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-[#1E3A5F] mb-1">
              Aucun voyage qui vous tente ?
            </h3>
            <p className="text-sm text-[#1E3A5F]/80 mb-3 leading-relaxed">
              Laissez-nous vos coordonnées, on vous prévient dès qu'un nouveau voyage sort.
            </p>
            <Link
              to="/restez-informe"
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center gap-2 bg-[#1E3A5F] text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-[#0f2540] transition shadow-md hover:shadow-lg"
              data-testid={`restez-informe-link-compact-${context}`}
            >
              Restez informé
              <span aria-hidden>→</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div
        className="text-center py-6 bg-blue-50 border-y border-blue-200"
        data-testid={`restez-informe-cta-inline-${context}`}
      >
        <p className="text-sm md:text-base text-[#1E3A5F]">
          <span aria-hidden className="mr-1">📬</span>
          Vous ne trouvez pas votre bonheur ?
          <Link
            to="/restez-informe"
            onClick={() => window.scrollTo(0, 0)}
            className="ml-2 font-bold text-[#5BC5D4] hover:text-[#3BA4B3] underline"
            data-testid={`restez-informe-link-inline-${context}`}
          >
            Laissez-nous vos coordonnées →
          </Link>
        </p>
      </div>
    );
  }

  // banner (default)
  return (
    <section
      className="py-12 md:py-16 bg-gradient-to-br from-[#FFF8DC] via-[#FFE894] to-[#FFC400] relative overflow-hidden"
      data-testid={`restez-informe-cta-banner-${context}`}
    >
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-80 h-80 bg-[#FFC400]/30 rounded-full blur-3xl" aria-hidden></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-[#FFE894]/30 rounded-full blur-3xl" aria-hidden></div>
      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-block bg-[#1E3A5F] text-[#FFC400] text-xs font-black px-4 py-1.5 rounded-full mb-4 tracking-wider uppercase">
            📬 Restons en contact
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1E3A5F] mb-4 leading-tight">
            Rejoignez notre liste de diffusion
          </h2>
          <p className="text-lg md:text-xl text-[#1E3A5F]/85 mb-8 leading-relaxed">
            Recevez en avant-première nos prochains voyages, nos bons plans et nos actualités.
            <br className="hidden md:block" />
            <span className="text-base text-[#1E3A5F]/70 italic">
              Restez en contact avec nous, même quand vous ne voyagez pas encore avec nous.
            </span>
          </p>
          <Link
            to="/restez-informe"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-3 bg-[#1E3A5F] text-white px-8 py-4 rounded-xl font-black text-lg hover:bg-[#0f2540] transition shadow-xl hover:shadow-2xl hover:scale-105"
            data-testid={`restez-informe-link-banner-${context}`}
          >
            <span aria-hidden>📬</span>
            Je laisse mes coordonnées
            <span aria-hidden>→</span>
          </Link>
          <p className="mt-4 text-xs text-[#1E3A5F]/60">
            Inscription en 30 secondes — Aucun engagement — Désinscription en 1 clic
          </p>
        </div>
      </div>
    </section>
  );
};

export default RestezInformeCTA;
